module.exports = __webpack_public_path__ + "img/NZD.e757573a.png";